import { render, staticRenderFns } from "./PageServiceModelEdit.vue?vue&type=template&id=b1585040&scoped=true&"
import script from "./PageServiceModelEdit.vue?vue&type=script&lang=js&"
export * from "./PageServiceModelEdit.vue?vue&type=script&lang=js&"
import style0 from "./PageServiceModelEdit.vue?vue&type=style&index=0&id=b1585040&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1585040",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VContainer,VIcon})
